import { render, staticRenderFns } from "./DisputeOrders.vue?vue&type=template&id=29c39908&scoped=true"
import script from "./DisputeOrders.vue?vue&type=script&lang=js"
export * from "./DisputeOrders.vue?vue&type=script&lang=js"
import style0 from "./DisputeOrders.vue?vue&type=style&index=0&id=29c39908&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29c39908",
  null
  
)

export default component.exports